bq.inlineSelect = function(element, options) {
    this.options   = options;
    this.$element  = $(element);
    this.active    = false;
    this.callCount = 0;
};

bq.inlineSelect.DEFAULTS = {
    maximumSelectionSize: 1,
    minimumInputLength: 0
};

bq.inlineSelect.prototype = {
    init: function() {
        let inputName = this.options.inputName;
        let inputSelector = '#' + inputName;
        let self = this;
        let $input = jQuery(inputSelector);

        // Check if Select2 is already initialized
        if ($input.hasClass('select2-offscreen') || $input.data('select2')) {
            console.log('Select2 already initialized for', inputSelector);
            return;
        }

        let config = {
            minimumInputLength: self.options.minimumInputLength,
            allowClear: true,
            maximumSelectionSize: self.options.maximumSelectionSize,
            multiple: true,
            escapeMarkup: function(m) {
                return m;
            }
        };

        if (this.options.initData) {
            config.data = this.options.initData;
        }

        if (this.options.ajaxUrl) {
            config.ajax = {
                url: this.options.ajaxUrl,
                    dataType: 'json',
                    data: function(term, page) {
                    return {
                        search: term
                    };
                },
                results: function (data, page) {
                    return { results: data };
                }
            };

            config.initSelection = function(element, callback) {
                var value = element.val();
                if (value && value !== '') {
                    if (self.options.initData && self.options.initData.length > 0) {
                        callback(self.options.initData);
                    } else {
                        jQuery.ajax({
                            url: self.options.ajaxUrl,
                            dataType: 'json',
                            data: {
                                search: value
                            }
                        }).done(function(data) {
                            if (data && data.length > 0) {
                                var match = data.find(function(item) {
                                    return item.id == value;
                                });
                                if (match) {
                                    callback(match);
                                }
                            }
                        });
                    }
                }
            };
        }

        $input.select2(config);
        let select2Input = jQuery('.select2-search-field input');
        $input.on('select2-open', function () {
            select2Input.attr('placeholder', $input.attr('data-placeholder'))
        });

        $input.on('select2-close', function() {
            select2Input.attr('placeholder', '');
            select2Input.blur();
        });

        // Disable input when maximum selection is reached
        if (self.options.maximumSelectionSize === 1) {
            // Check on initialization
            self._toggleInputState($input);

            // Check when selection changes
            $input.on('change', function() {
                self._toggleInputState($input);
            });

            // Prevent opening dropdown when selection exists, but allow clearing
            $input.on('select2-opening', function(e) {
                var data = $input.select2('data');
                var hasSelection = data && data.length > 0;

                if (hasSelection) {
                    e.preventDefault();
                    return false;
                }
            });
        }
    },

    _toggleInputState: function($input) {
        var data = $input.select2('data');
        var hasSelection = data && data.length > 0;
        var $container = $input.parent().find('.select2-container');

        if (hasSelection) {
            $container.find('.select2-input').css({
                'visibility': 'hidden'
            });
        } else {
            $container.find('.select2-input').css({
                'visibility': 'visible'
            });
        }
    },

    destroy: function() {
        let inputName = this.options.inputName;
        let inputSelector = '#' + inputName;
        let $input = jQuery(inputSelector);

        // Destroy Select2 if it exists
        if ($input.hasClass('select2-offscreen') || $input.data('select2')) {
            $input.off('select2-open select2-close select2-opening change');
            $input.select2('destroy');
            console.log('Select2 destroyed for', inputSelector);
        }
    }
};

// LOAD BLOCK PLUGIN DEFINITION
// =======================

var inlineSelectold = $.fn.inlineSelect;

$.fn.inlineSelect = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.loadBlock');
        var options = $.extend({}, bq.inlineSelect.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.loadBlock', (data = new bq.inlineSelect(this, options))); }
        data.init();
    });
};

$.fn.inlineSelect.Constructor = bq.inlineSelect;

// LOAD BLOCK NO CONFLICT
// =================

$.fn.inlineSelect.noConflict = function () {
    $.fn.inlineSelect = inlineSelectold;
    return this;
};

bq.inlineSelectInit = function() {
    $('[data-bq="inline-select"]').each(function () {
        var el = $(this);
        if(el.data('bq.inlineSelect')) { return; }
        el.inlineSelect(el.data());
    });
};

bq.init.push(bq.inlineSelectInit);
